import { useQuery } from '@apollo/client';

import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import LearnerProfileOccupationPreferencesQuery from 'bundles/onboarding-common/queries/LearnerProfileOccupationPreferences.graphql';
import type {
  LearnerProfileOccupationPreferencesQueryQuery,
  LearnerProfileOccupationPreferencesQueryQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerProfileOccupationPreferences';
import { formatOccupationPreferencesFromLearnerProfile } from 'bundles/onboarding-common/utils/savedQuestionDataUtils';

const useOccupationPreferencesData = ({ skip }: { skip?: boolean }) => {
  const { data, loading } = useQuery<
    LearnerProfileOccupationPreferencesQueryQuery,
    LearnerProfileOccupationPreferencesQueryQueryVariables
  >(LearnerProfileOccupationPreferencesQuery, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    skip,
  });

  return {
    value: formatOccupationPreferencesFromLearnerProfile(data),
    loading,
    __typename: QUESTION_IDS.roleSelect,
  };
};

export default useOccupationPreferencesData;
